<!-- Do not change this file. -->

<template>
  <div class="col-6 col-sm-auto">
    <button class="btn btn-link m-0 p-0 my-auto ms-3" @click="toggleVersion">
      {{ version }}
      <span v-if="hasUpdate" class="badge badge rounded-pill bg-danger"
        >Update available</span
      >
    </button>
  </div>
</template>

<script>
/* Do not change this file. */
import VersionCheck from "@/components/core/VersionCheck.vue";

// hasUpdate is set by the mixin
// 💡 -- VersionCheck could be in the template, and responsible for showing
// the update message, instead of using an event and prop

export default {
  name: "TheFooter",
  mixins: [VersionCheck],
  data: () => {
    return {
      showVersion: false
    };
  },
  computed: {
    version() {
      if (this.showVersion) {
        return document.lastModified;
      } else {
        return `v${this.$s("version")}`;
      }
    }
  },
  methods: {
    toggleVersion() {
      this.showVersion = !this.showVersion;
    }
  }
};
</script>
